<template>
    <div v-if="banners.length" class="topicBanners topicBanners--fullWidth">
        <div :id="`js-slim-carousel-${carouselId}`" ref="carousel" class="slim-carousel">
            <a
                v-if="banners.length > 4"
                href="#"
                class="slim-carousel__control slim-carousel__control--left js-slime-carousel-left d-none"
                :aria-label="$t('slides.previous')"
            >
                <img :src="`/nuxt-assets/icons/arrow.svg`" alt="arrow" width="11" height="20" />
            </a>
            <a
                v-if="banners.length > 4"
                href="#"
                class="slim-carousel__control slim-carousel__control--right js-slime-carousel-right"
                :aria-label="$t('slides.next')"
            >
                <img :src="`/nuxt-assets/icons/arrow.svg`" alt="arrow" width="11" height="20" />
            </a>
            <div class="slim-carousel__container js-slim-carousel-scroll-container">
                <div
                    v-for="(item, index) in validBanners"
                    :key="index"
                    class="slim-carousel__item slim-carousel__item--banners"
                    :data-id="item.id"
                    :data-title="item.title"
                >
                    <SkeletonBannerCategorySkeleton v-if="loading" />
                    <TopicBannerObject v-else :banner="item" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import { MetaInfo } from 'vue-meta/types/vue-meta'
import SlimCarousel from '~/mixins/SlimCarousel'
import TopicBanner from '~/models/Banners/TopicBanner'
import TopicBannerObject from '~/components/objects/TopicBannerObject.vue'
let id = 200

export default {
    components: {
        TopicBannerObject,
    },

    props: {
        banners: {
            type: Array as PropType<TopicBanner[]>,
            required: true,
        },
    },

    data() {
        return {
            carouselId: null,
            loading: true,
        }
    },

    // @ts-ignore
    head() {
        const head: MetaInfo = {
            link: [],
        }

        this.banners.forEach((banner: TopicBanner, index: number) => {
            if (index < 4) {
                head.link?.push({
                    rel: 'preload',
                    href: banner.image,
                    as: 'image',
                })
            }
        })

        return head
    },

    computed: {
        validBanners() {
            const items: TopicBanner[] = []
            this.banners.forEach((banner: TopicBanner) => {
                try {
                    new URL(banner.url)

                    items.push(banner)
                } catch {}
            })

            return items
        },
    },

    created() {
        id++
        this.carouselId = id
    },

    updated() {
        if (this.$refs.carousel) {
            new SlimCarousel({ el: this.$refs.carousel.id })
        }
    },

    mounted() {
        this.loading = false
        if (this.$refs.carousel) {
            new SlimCarousel({ el: this.$refs.carousel.id })
        }
    },
}
</script>

<style lang="scss" scoped>
.topicBanners {
    &--fullWidth {
        margin-top: 10px;
        width: calc(100% + 2 * $padding-container-inside-mobile);
        margin-left: -$padding-container-inside-mobile;

        @media (min-width: 576px) {
            width: calc(100% + 40px);
            max-width: calc($max-width-container-inside + 40px);
            margin-left: -20px;
        }

        @media (min-width: $max-width-container-inside) {
            margin-left: 0;
            width: 100%;
            max-width: $max-width-container-inside;
        }
    }
}

.slim-carousel {
    position: relative;

    @media (min-width: 480px) {
        margin-bottom: 1rem;
    }
}

.slim-carousel__container {
    display: flex;
    padding: 15px 15px;
    height: auto;
    overflow-x: auto;
    width: 100%;
    gap: 15px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-bottom: 10px;

    @media (min-width: 576px) {
        padding: 15px 20px;
    }

    @media (min-width: $max-width-container-inside) {
        padding: 15px 1px;
    }

    &::-webkit-scrollbar {
        -webkit-appearance: none;
        height: 10px;
    }

    &:hover::-webkit-scrollbar-thumb {
        border: 0;
        background-color: $color-grey-semi-dark;
        border-radius: 10px;
        cursor: pointer;

        @media (min-width: 890px) {
            display: none;
        }
    }
}

.slim-carousel__control {
    display: none;
    padding-left: 3px;

    @media (min-width: 890px) {
        position: absolute;
        top: calc(50% - 42px);
        width: 33px;
        height: 33px;
        border-radius: 33px;
        transition: all 0.3s;
        z-index: 5;
        background-color: $color-purple;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &:hover {
        @media (min-width: 1024px) {
            background-color: $color-purple-dark;
        }
    }

    &--left {
        @media (min-width: 890px) {
            left: 0;
            transform: rotate(180deg);
        }
        @media (min-width: $max-width-container-inside) {
            left: -16px;
        }
    }

    &--right {
        @media (min-width: 890px) {
            right: 0;
        }
        @media (min-width: $max-width-container-inside) {
            right: -16px;
        }
    }

    &:deep(svg) {
        margin-left: 2px;
        fill: $color-white;
    }
}

.slim-carousel__item--banners {
    display: flex;
    flex: 0 0 calc(100% / 1.5);
    min-width: 180px;

    @media (min-width: 600px) {
        flex: 0 0 calc(100% / 3);
    }
    @media (min-width: 1024px) {
        flex: 0 0 calc(100% / 4.5);
    }
}
</style>
